import { memo, type FC, type KeyboardEvent } from 'react';
import { KEYBOARD_KEYS } from 'constants/keyboard';

import styles from './styles.module.scss';

import type { TStatusCard } from './types';

type StatusCardProps = TStatusCard & {
  valueFormatter: (value: number) => string;
  isInteractive?: boolean;
  isActive?: boolean;
  onSelect?: (statusId?: string) => void;
};

const StatusCardItem: FC<StatusCardProps> = ({
  id,
  label,
  value,
  valueFormatter,
  isInteractive,
  isActive,
  onSelect,
}) => {
  const statusKey = id || 'default';

  const handleSelect = () => {
    if (isInteractive) {
      onSelect?.(id);
    }
  };

  const handleKeyDown = (event: KeyboardEvent<HTMLButtonElement>) => {
    if (!isInteractive) return;
    if (
      event.key === KEYBOARD_KEYS.ENTER ||
      event.key === KEYBOARD_KEYS.SPACE
    ) {
      event.preventDefault();
      onSelect?.(id);
    }
  };

  return (
    <div className={styles['status-wrapper']}>
      <button
        type="button"
        className={styles['status-card']}
        data-status={statusKey}
        data-clickable={isInteractive}
        data-active={isActive}
        disabled={!isInteractive}
        onClick={handleSelect}
        onKeyDown={handleKeyDown}
      >
        <span className={styles['status-label']}>{label}</span>
        <div className={styles['status-value']}>{valueFormatter(value)}</div>
      </button>
    </div>
  );
};

export default memo(StatusCardItem);
